import {
    IAllocation,
    IAllocationSearchParameters,
} from '@/interfaces/allocation';
import { IConfig, IAllocationsApiEndpoints } from '@/interfaces/configuration';
import baseAjaxCall, {
    initWebStore,
    disableInterceptorKey,
} from '@/tools/ajax-wrapper';
import { Endpoints } from './endpoints';

interface IResultWrapper<T> {
    result: T;
    errors?: string[];
    hasError?: boolean;
}

interface IBasicParameter<T> {
    parameter: T;
}

function getHeadersToBypassAxiosInterceptor() {
    // Hack for public endpoints - maintain urls instead ?
    // Axios interceptor can be disabled adding specific key to requests headers
    // !!!! If user is not authenticated, Interceptor run into authentication process
    const headers: Record<string, any> = {};
    headers[disableInterceptorKey] = true;
    return headers;
}

function fixAllocationFromWSCall(allocation: IAllocation) {
    // Fix Dates : string to Date
    allocation.validityStartDate = new Date(allocation.validityStartDate);
    allocation.validityEndDate = new Date(allocation.validityEndDate);
}

function fixAllocationsResultWrapperFromWsCall(
    res: IResultWrapper<IAllocation[]>
) {
    if (res && res.result?.length > 0) {
        res.result.forEach(fixAllocationFromWSCall);
    }
    return res;
}

async function searchAllocationData<T>(searchParameters: IAllocationSearchParameters): Promise<T> {
    const apiUrl = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_URL_PRODUCTION : process.env.VUE_APP_API_URL_DEVELOPMENT;
    let date;
    if (typeof(searchParameters.departureDate) == 'object')
        date = searchParameters.departureDate.toLocaleDateString("en-CA");
    else
        date = searchParameters.departureDate;
    const url = `${apiUrl}/GetAllocations?date=${date}&from=${searchParameters.from}&to=${searchParameters.to}`;
    const response: any = await baseAjaxCall('get',url, (v) => v) ;

    return response.datas;
}

export function mockSearch(searchParameters: IAllocationSearchParameters) {
    return [
        {
            reference: 'NL9956-1665-13-001',
            shippingLine: 'CMACGM_WW',
            client: 'MDM',
            validityStartDate: new Date(),
            validityEndDate: new Date(),
            trade: 'DE-NCP',
            service: 'FAL1/FAL3',
            teusCount: 12,
            consoCount: 2,
            contactCapacity: 20,
            conso: ['CNSHA033656', 'CNSHA033657'],
            branches: ['CDG, LYS', 'CDG'],
        },
        {
            reference: 'NL9956-1665-13-002',
            shippingLine: 'CMACGM_WW',
            client: 'MDM',
            validityStartDate: new Date(),
            validityEndDate: new Date(),
            trade: 'DE-NCP',
            service: 'FAL1/FAL3',
            teusCount: 2,
            consoCount: 2,
            contactCapacity: 20,
            conso: ['CNSHA033656', 'CNSHA033657', 'CNSHA033658'],
            branches: ['CDG, LYS', 'CDG'],
        },
    ] as IAllocation[];
}

export const ws = {
    initWebStore() {
        initWebStore();
    },

    async getConfiguration() {
        return baseAjaxCall<IConfig>(
            'get',
            '/configuration/config.json',
            (val) => val
        ).then((r) => {
            return r.datas;
        });
    },

    async searchAllocations(searchParameters: IAllocationSearchParameters) {
        // ///////////////////
        // TODO: comment/remove to call ws instead mock
        const searchResults = (await searchAllocationData<IAllocation[]>(searchParameters));
        //const searchResults = mockSearch(searchParameters);
        return {
            result: searchResults
        };
        // ///////////////////

        // const retVal = await baseAjaxCall<
        //     IResultWrapper<IAllocation[]>,
        //     IAllocationSearchParameters
        // >(
        //     'post',
        //     Endpoints.getAllocationsEndpointUrl('searchAllocations'),
        //     fixAllocationsResultWrapperFromWsCall,
        //     null,
        //     searchParameters
        // );
        // return retVal.datas;
    },
};
